import { jsx as _jsx } from "react/jsx-runtime";
import MuiScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import React, { forwardRef } from 'react';
export const RubiksCssBaseline = forwardRef((props, ref) => {
    return (_jsx(MuiScopedCssBaseline, { ref: ref, ...props, sx: {
            display: 'contents',
            background: 'inherit',
            ...props.sx
        } }));
});
